export default (namespace) => ({
  [`${namespace}.cannotInsureHome`]:
    'Lo sentimos pero no podemos asegurar tu vivienda',
});
